// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3zzda","list":"styles_list__30grh"};